import { Component, inject, QueryList, ViewChildren } from '@angular/core';
import { ServiceNavTileComponent } from '../../components/service-nav-tile/service-nav-tile.component';
import { UnauthPageIntroComponent } from '../../components/unauth-page-intro/unauth-page-intro.component';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';
import { PUBLIC_MARKETING_RUNTIME_CONFIG } from '../../tokens/public-marketing-runtime.token';
import { ViewDidLeave, ViewWillEnter } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { briefcaseOutline, businessOutline, readerOutline, tvOutline } from 'ionicons/icons';
addIcons({
  businessOutline,
  briefcaseOutline,
  readerOutline,
  tvOutline,
});

@Component({
  selector: 'app-about-how-it-works',
  standalone: true,
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent, ServiceNavTileComponent],
  templateUrl: './about-how-it-works.component.html',
  styleUrls: ['./about-project.component.css', './about-how-it-works.component.css'],
})
export class AboutHowItWorksComponent implements ViewWillEnter, ViewDidLeave {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  readonly marketing = inject(PUBLIC_MARKETING_RUNTIME_CONFIG);

  @ViewChildren(ServiceNavTileComponent) serviceTiles!: QueryList<ServiceNavTileComponent>;

  readonly pageTitle = 'How it all works';

  private readonly appKey = this.marketing.appName.trim().toLowerCase();
  readonly isServiceApp = this.appKey === 'service';
  readonly isFormsApp = this.appKey === 'forms';

  ionViewWillEnter(): void {
    this.resetServiceNavTiles();
  }

  ionViewDidLeave(): void {
    this.resetServiceNavTiles();
  }

  private resetServiceNavTiles(): void {
    this.serviceTiles?.forEach((t) => t.resetLoadingState());
  }
}
